export { M30ProductCarouselBlock } from './M30ProductCarousel';
export { M30ProductCarouselBlock as default } from './M30ProductCarousel';
